<template>
  <div class="ba-flex ba-flex-col ba-items-center ba-m-auto ba-p-4 ba-w-full">
    <div class="ba-w-full ba-text-center">
      <span class="far fa-exclamation-circle" :class="sizeClass" />
      <div v-if="$slots['default']" class="ba-mt-2">
        <slot></slot>
      </div>
      <div
        class="ba-mt-2 ba-flex ba-flex-col ba-text-center"
        v-if="withDefault"
      >
        <div class="ba-mb-2">
          {{ message || $t("errorFetchData") }}
        </div>
        <a
          v-if="backToHome"
          :href="getErrorBackUrl(state)"
          @click="onBackToHome"
          class="ba-text-link ba-underline hover:ba-no-underline"
        >
          {{ backMessage || $t("backToHome") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { errorUtilMixin } from "@ba/visary-account-common-vue";

export default {
  name: "vis-error",
  mixins: [errorUtilMixin],
  props: {
    logo: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "",
      validator: (v) => ["xs", "sm", "md", "lg", ""].indexOf(v) !== -1
    },
    withDefault: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: null
    },
    backMessage: {
      type: String,
      default: null
    },
    backToHome: {
      type: Boolean,
      default: true
    },
    backToHomeEvent: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: undefined
    }
  },
  computed: {
    sizeClass() {
      switch (this.size) {
        case "lg":
          return "ba-text-6xl";
        case "sm":
          return "ba-text-3xl";
        case "xs":
          return "ba-text-xl";
        case "md":
          return "ba-text-5xl";
        default:
          return "";
      }
    }
  },
  methods: {
    onBackToHome(e) {
      if (this.backToHomeEvent) {
        e.preventDefault();
        this.$emit("back-click");
      }
    }
  }
};
</script>
